export const areListEqual = (xs: any[], ys: any[]) =>
  xs.length === ys.length &&
  // @ts-ignore
  xs.every((x) => ys.includes(x));
